import { EventEmitter, OnInit } from '@angular/core';
import { Menu } from '../../../../menu/menu.model';
import { Router } from '@angular/router';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { normalizePath, slugify } from '@app/shared/utils';
var BurgerModalOptionComponent = /** @class */ (function () {
    function BurgerModalOptionComponent(router, _sdkAnalyticsService) {
        this.router = router;
        this._sdkAnalyticsService = _sdkAnalyticsService;
        this.closeModal = new EventEmitter();
    }
    BurgerModalOptionComponent.prototype.ngOnInit = function () {
        this.name = this.getOptionName();
    };
    BurgerModalOptionComponent.prototype.openMenu = function () {
        if (this.getOptionName() && this.router && this.router.url) {
            this._sdkAnalyticsService.trackEvent('click', {
                custom_path: normalizePath(this.router.url),
                implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
                detail: 'menu-lateral-' + slugify(this.getOptionName())
            });
        }
        this.router.navigate(["/menu", { 'menuName': this.getOptionName() }]);
        this.closeModal.emit(true);
    };
    BurgerModalOptionComponent.prototype.getOptionName = function () {
        if (!this.option || !this.option.name) {
            return '';
        }
        return this.option.name.toLowerCase();
    };
    Object.defineProperty(BurgerModalOptionComponent.prototype, "translationKey", {
        get: function () {
            if (!this.option || !this.option.translationKey) {
                return '';
            }
            return this.option.translationKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BurgerModalOptionComponent.prototype, "optionName", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    return BurgerModalOptionComponent;
}());
export { BurgerModalOptionComponent };
